
import Vue from 'vue'
import ProductSectionProducts from '@/categories/components/ProductSectionProducts.vue'
import { SectionProductsType } from '@/types'

interface Data {
  selectedKey: number
}

export default Vue.extend({
  components: {
    ProductSectionProducts
  },
  props: {
    sectionProducts: {
      type: Array as () => SectionProductsType[],
      required: true
    },
    sectionTitle: {
      type: String,
      required: false,
      default: null
    }
  },
  data(): Data {
    return {
      selectedKey: 0
    }
  },
  computed: {
    filteredProductsSection(): SectionProductsType[] {
      return this.sectionProducts.filter(section => section.products.length !== 0)
    }
  },
  methods: {
    updateSelectedKey(key: number): void {
      this.selectedKey = key
    },
    isSelected(key: number): boolean {
      return key === this.selectedKey
    }
  }
})
